import type {FC} from 'react';
import {DayPicker} from 'react-day-picker';
import type {DateRange} from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import {Theme} from '@wellstone-solutions/common';

interface DayPickerCalendarProps {
  selected?: DateRange | null;
  onSelect?: (range: DateRange | null) => void;
}

export const DayPickerCalendar: FC<DayPickerCalendarProps> = ({
  selected,
  onSelect,
  ...props
}) => {
  const today = new Date();

  return (
    <DayPicker
      animate
      mode="range"
      disabled={{after: today}}
      selected={selected || undefined}
      onSelect={onSelect}
      defaultMonth={selected?.from || today}
      today={today}
      style={styles.dayPicker}
      classNames={{
        today: 'today',
      }}
      {...props}
    />
  );
};

const styles = {
  dayPicker: {
    position: 'relative' as const,
    boxSizing: 'border-box' as const,
    '--rdp-accent-color': Theme.colorPalette.primary,
    '--rdp-accent-background-color': '#f0f0ff',
    '--rdp-day-height': '44px',
    '--rdp-day-width': '44px',
    '--rdp-day_button-border-radius': '100%',
    '--rdp-day_button-border': '2px solid transparent',
    '--rdp-day_button-height': '42px',
    '--rdp-day_button-width': '42px',
    '--rdp-selected-border': `2px solid ${Theme.colorPalette.primary}`,
    '--rdp-disabled-opacity': '0.5',
    '--rdp-outside-opacity': '0.75',
    '--rdp-weekday-font-weight': '500',
    '--rdp-weekday-font-size': 'smaller',
    '--rdp-weekdays-color': Theme.colorPalette.medium,
    marginBottom: 2,
  },
};
